module.exports = __webpack_public_path__ + "static/media/balk_afm3.92da21aa.jpg";